'use client';

import { useState } from 'react';

const FALLBACK_COLORS: Record<string, string> = {
  BTC: '#f7931a', ETH: '#627eea', BNB: '#f0b90b', SOL: '#9945ff', XRP: '#23292f',
  DOGE: '#c2a633', ADA: '#0033ad', AVAX: '#e84142', LINK: '#2a5ada', DOT: '#e6007a',
  LTC: '#345d9d', BCH: '#8dc351', UNI: '#ff007a', ATOM: '#6f7390', NEAR: '#00ec97',
  FIL: '#0090ff', APT: '#5fc0c5', ARB: '#28a0f0', OP: '#ff0420', SUI: '#4da2ff',
  HYPE: '#7c3aed', ONDO: '#1a1a2e', ENA: '#0052ff', WLD: '#7c3aed',
  PEPE: '#3d8748', SHIB: '#ffa409', FLOKI: '#cf811a', WIF: '#b7a18a',
  BONK: '#f2a628', JUP: '#14f0b1', RENDER: '#70e000', MKR: '#1ab4e4',
  INJ: '#00a0e4', TIA: '#7b2fe6', SEI: '#4a9fef', AAVE: '#b6509e',
  RNDR: '#70e000', GRT: '#6f4cff', IMX: '#5c4ddb', SXP: '#4a8b3d',
  KAS: '#70c7ba', TAO: '#2f2f2f', HBAR: '#1a4a7c', ALGO: '#000000',
  VET: '#15666c', ICP: '#3b67f8', FTM: '#1969ff',
  MANA: '#ff2d55', SAND: '#00a8e0', AXS: '#0055d5', GALA: '#d72b3f',
  GMT: '#22b573', APE: '#0054ff',
  USDC: '#2775ca', USDT: '#26a17b', DAI: '#f5ac37',
};

export default function CoinLogo({ symbol, size = 24 }: { symbol: string; size?: number }) {
  // Extract base asset: strip quote currencies from the END only
  let base = symbol;
  const quotes = ['USDT', 'USDC', 'FDUSD', 'TRY', 'BUSD', 'TUSD', 'DAI'];
  for (const q of quotes) {
    if (base.endsWith(q)) {
      base = base.slice(0, -q.length);
      break;
    }
  }
  base = base.toLowerCase();
  const upper = base.toUpperCase();
  const [failed, setFailed] = useState(false);

  if (failed || !base) {
    const color = FALLBACK_COLORS[upper] || '#6b7280';
    return (
      <div
        className="flex shrink-0 items-center justify-center rounded-full font-bold text-white"
        style={{ width: size, height: size, backgroundColor: color, fontSize: size * 0.4 }}
      >
        {upper.slice(0, 1) || '?'}
      </div>
    );
  }

  return (
    <img
      src={`/api/v1/coin-logo/${base}`}
      alt={upper}
      width={size}
      height={size}
      className="shrink-0 rounded-full"
      onError={() => setFailed(true)}
      loading="lazy"
    />
  );
}
